import { render, staticRenderFns } from "./EditEventSeries.vue?vue&type=template&id=79f68976&scoped=true"
import script from "./EditEventSeries.vue?vue&type=script&lang=js"
export * from "./EditEventSeries.vue?vue&type=script&lang=js"
import style0 from "./EditEventSeries.vue?vue&type=style&index=0&id=79f68976&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f68976",
  null
  
)

export default component.exports